import styles from '../CommonCss/OrderEngineCommon.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import WaitLoader from "../../../WaitLoader/WaitLoader";


interface UpdateOrderInt
{
    orderId:string
    ctn?:string
    useAsDelivery:boolean

}

interface OrderEngineChangePhoneInt
{
    orderId:string
    pCtn?:string
    onClose: ()=>void
    onSuccess?: ()=>void


}

export default function OrderEngineChangePhone({orderId,onClose,onSuccess,pCtn}:OrderEngineChangePhoneInt){

    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/contact/phone/change","post",orderUpdateData);


    const updatePhone = useRef<ErrorLineItemRef>(null)

    const [ctn, setCtn] = useState(pCtn ? pCtn : "-" )
    const [valid, setValid] = useState(false)
    const [useAsDelivery, setUseAsDelivery] = useState(true)

    useEffect(()=>{
        const vCtn = ctn?.match(/^[0-9]{10}$/ui)
        if(vCtn ) setValid(true)
        else setValid(false)


    },[ctn])


    const handleUpdatePhone = () =>{
        const x = ctn?.match(/^[0-9]{10}$/ui)
        if(!x){
            if(updatePhone?.current)updatePhone?.current?.show("Не корректный номер", true,3000)
            return
        }
        orderUpdateData.current = {
            orderId: orderId,
            ctn: x[0],
            useAsDelivery: useAsDelivery

        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(updatePhone.current)updatePhone.current.show(`Контактный телефон в заказа ${orderId} обновлен`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updatePhone.current)updatePhone.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        })
    }


    return(
        <ModalWindow>
            <MainFormTemplate title={`Контактный телефон заказ [${orderId}]`} maxWidth={"450px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={ctn ? ctn : "-"}
                            mode={"ie"}
                            info={"Номер [XXXXXXXXXX]"}
                            title={"Номер"}
                            regExp={/^[0-9]{10}$/}
                            titleShift={0}
                            onChange={(e)=>{
                                setCtn(e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={useAsDelivery}
                            title={"Использовать при доставке"}
                            mode={"e"}
                            inputType={1}
                            onChange={(e)=>{
                                setUseAsDelivery(!!e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <ErrorLineItem ref={updatePhone} ></ErrorLineItem>

                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!valid}
                                onClick={(e)=>{
                                    handleUpdatePhone()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate } api={rsOrderUpdate} onlyLoading={true}>

                    </WaitLoader>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}